import { IReportSection } from '@modeso/aumico-lib-annualreport-fe';

export interface IReorderingReportData {
    reportSections: IReportSection[];
    showTOC: boolean;
    showCoverPage: boolean;
    printOrder: string[];
}
